import "../Basic/Navbar.css";

import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { authContext } from "../../Context/AuthContext";

function Navbar() {
  const navigate = useNavigate();
  const { isAuth, name,logout } = useContext(authContext);
  return (
    <div className="navbar">
      <div className="logobox">
        <img
        src={`${process.env.REACT_APP_STATIC_URL}/Logo.jpeg`}
          alt="logo"
          className="logo-navbar"
          onClick={() => {
            navigate("/");
          }}
        />
      </div>
      <div className="ButtonBox">
        <div>
          { isAuth ? <button>Welcone {name}</button> : (<button
            className="loginbtn"
            onClick={() => {
              navigate("/login");
            }}>
            Login
          </button>) }
        </div>
        <div>{ isAuth ? (<button
            className="signinbtn"
            onClick={() => {
                logout();
                navigate("/");
            }}>
            Logout </button>) : (<button
            className="signinbtn"
            onClick={() => {
                navigate("/register");
            }}
          >
            SignUp
          </button>)
        }</div>
      </div>
    </div>
  );
}

export default Navbar;
